/**
 * Navigate to the compose-message screen, carrying the caller path and any
 * preselected recipients / collaborator ids in location.state so they survive
 * the /messages remount (startCreateMessage).
 *
 * @param {Function} navigate
 * @param {{ pathname?: string, search?: string, hash?: string }} location
 * @param {object} extraState
 */
export function push_messages_with_back(navigate, location, extraState = {}) {
    const backTo = `${location?.pathname || ''}${location?.search || ''}${location?.hash || ''}`;
    navigate('/messages', { state: { backTo, ...extraState } });
}

/**
 * Re-apply compose targets after startCreateMessage.
 * `actions` are already bound (mapDispatchToProps / connected).
 *
 * @param {object} locationState
 * @param {{ setRecipients: Function, setUsersIds: Function, setActivitiesIds: Function }} actions
 */
export function apply_message_compose_location_state(locationState, actions) {
    const recipients = locationState?.recipients;
    const users_ids = locationState?.users_ids;
    const activities_ids = locationState?.activities_ids;

    if (Array.isArray(recipients) && recipients.length) {
        actions.setRecipients(recipients);
        return;
    }
    if (Array.isArray(users_ids) && users_ids.length) {
        actions.setUsersIds(users_ids);
        return;
    }
    if (Array.isArray(activities_ids) && activities_ids.length)
        actions.setActivitiesIds(activities_ids);
}
